import { render, staticRenderFns } from "./jeniskiriman.vue?vue&type=template&id=5d9a1702"
import script from "./jeniskiriman.vue?vue&type=script&lang=js"
export * from "./jeniskiriman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports